import { render, staticRenderFns } from "./EditInsuranceModal.vue?vue&type=template&id=1cdd4481"
import script from "./EditInsuranceModal.vue?vue&type=script&lang=js"
export * from "./EditInsuranceModal.vue?vue&type=script&lang=js"
import style0 from "./EditInsuranceModal.vue?vue&type=style&index=0&id=1cdd4481&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports